// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__tBl7e","savePackageButton":"ClientWallet_savePackageButton__zGS1u"};